// extracted by mini-css-extract-plugin
module.exports = {"Head":"_3FVIgImB","title":"_3PE0S2uv","aggregations":"v7jygR9D","aggregation":"_3sdv3sVt","badge":"_2vLcAnnY"};